import { render, staticRenderFns } from "./ProposalsTab.vue?vue&type=template&id=f9ff1da6&scoped=true"
import script from "./ProposalsTab.vue?vue&type=script&lang=js"
export * from "./ProposalsTab.vue?vue&type=script&lang=js"
import style0 from "./ProposalsTab.vue?vue&type=style&index=0&id=f9ff1da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ff1da6",
  null
  
)

export default component.exports